import {Modal} from "antd";

export function showDeleteConfirm(title: string, ok: any) {
  Modal.confirm({
    title,
    content: 'Si per continuare',
    okText: 'SI',
    okType: 'danger',
    cancelText: 'No',
    onOk() {
      ok()
    },
    onCancel() {
      console.log('Cancel')
    },
  })
}
